export default "/images/microsoft.png?2794678c859f61efb5d25d8185e9d4bd";